import { Column } from '@/presentation/components/table';
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle,
} from 'react-icons/fa';
import { UserUpload } from '.';

export const columnsUserUpload: Column<UserUpload>[] = [
  {
    header: 'NID',
    accessor: 'id',
  },
  {
    header: 'Nombre',
    accessor: 'name',
  },
  {
    header: 'Correo',
    accessor: 'email',
  },
  {
    header: 'Departamento',
    accessor: 'department',
  },
  {
    header: 'Area',
    accessor: 'area',
  },
  {
    header: 'Cargo',
    accessor: 'position',
  },
  {
    header: 'Unidad',
    accessor: 'unit',
  },

  {
    header: 'Estado',
    accessor: 'isEnabled',
    render: (row) => {
      return row ? (
        <span className="text-green-600 flex items-center gap-2">
          <FaCheckCircle />
          Activar
        </span>
      ) : (
        <span className="text-red-600 flex items-center gap-2">
          <FaTimesCircle />
          Desactivar
        </span>
      );
    },
  },
  {
    header: 'Mensaje',
    accessor: 'message',
  },
  {
    header: '',
    accessor: 'status',
    render: (row) => {
      if (row && typeof row === 'string') {
        return row === 'success' ? (
          <FaCheckCircle className="text-green-500" />
        ) : row === 'error' ? (
          <FaExclamationTriangle className="text-red-500" />
        ) : null;
      }
      return null;
    },
  },
];
